import { render, staticRenderFns } from "./QuestionMult2.vue?vue&type=template&id=5b431dc0&scoped=true&"
import script from "./QuestionMult2.vue?vue&type=script&lang=js&"
export * from "./QuestionMult2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMult2.vue?vue&type=style&index=0&id=5b431dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b431dc0",
  null
  
)

export default component.exports